import { styled } from '@mui/material/styles'
import Grid from '@mui/material/Grid'
import MainBg from '../../assets/mainBg.png'

export const StyledLayout = styled(Grid)(({ theme }) => ({
  background: `url('${MainBg}')`,  
  minHeight: '100vh',
  [theme.breakpoints.up('lg')]:{
    backgroundSize: 'cover',
  },
  [theme.breakpoints.down('lg')]:{
    backgroundSize: 'contain',
  }
}))
